import { getExternalUserId } from 'api/utils'
import { useAuth } from 'auth'
import { GlobalShell } from 'components/GlobalShell'
import { useWorkspaceChange } from 'hooks/useWorkspaceChange'
import { OrganizationType } from 'lib/generated/api'
import { useHistory, useLocation } from 'lib/router'
import { useHydrateStore, useStore } from 'state/store'
import ConnectionsSelector from 'views/ConnectionsSelector'

export const ConnectionsSelectorContainer = () => {
  const history = useHistory()
  const location = useLocation()
  const { latestToken: token } = useAuth()
  const setRitualLogoType = useStore(state => state.setRitualLogoType)
  const onWorkspaceChange = useWorkspaceChange()
  useHydrateStore(getExternalUserId(token))

  setRitualLogoType(OrganizationType.Company)

  return (
    <GlobalShell>
      <ConnectionsSelector
        onWorkspaceSelect={ids => {
          onWorkspaceChange(ids)
          history.push(
            `/workspaces/${ids.workspaceId}/settings/connections${location.search}`
          )
        }}
      />
    </GlobalShell>
  )
}
